import(/* webpackMode: "eager" */ "/root/project/packages/studio/app/(app)/integrations/page.tsx");
